"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfMedicalHistoryOutput = instanceOfMedicalHistoryOutput;
exports.MedicalHistoryOutputFromJSON = MedicalHistoryOutputFromJSON;
exports.MedicalHistoryOutputFromJSONTyped = MedicalHistoryOutputFromJSONTyped;
exports.MedicalHistoryOutputToJSON = MedicalHistoryOutputToJSON;
var MedicalHistory_1 = require("./MedicalHistory");
var Metadata_1 = require("./Metadata");
/**
 * Check if a given object implements the MedicalHistoryOutput interface.
 */
function instanceOfMedicalHistoryOutput(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function MedicalHistoryOutputFromJSON(json) {
    return MedicalHistoryOutputFromJSONTyped(json, false);
}
function MedicalHistoryOutputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(MedicalHistory_1.MedicalHistoryFromJSON)),
        'metadata': json['metadata'] == null ? undefined : (0, Metadata_1.MetadataFromJSON)(json['metadata']),
    };
}
function MedicalHistoryOutputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(MedicalHistory_1.MedicalHistoryToJSON)),
        'metadata': (0, Metadata_1.MetadataToJSON)(value['metadata']),
    };
}
